export const TEST = 'TEST'
export const DEFAULT = 'Default'

export const MENU_FOLD_OUT = 'MENU_FOLD_OUT'
export const MENU_UNFOLD_OUT = 'MENU_UNFOLD_OUT'
export const SIDER_BREAKPOINT_FOLD = 'SIDER_BREAKPOINT_FOLD'
export const SIDER_BREAKPOINT_UNFOLD = 'SIDER_BREAKPOINT_UNFOLD'

export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_GET_ROLE = 'USER_GET_ROLE'
export const USER_GET_PLAN = 'USER_GET_PLAN'
export const USER_APPLY_ARTIST = 'USER_APPLY_ARTIST'

export const ARTIST_SAVE = 'ARTIST_SAVE'
export const ARTIST_NAME_SAVE = 'ARTIST_NAME_SAVE'
export const ADMIN_CHANGE_ARTIST = 'ADMIN_CHANGE_ARTIST'

export const PAGINATION_SAVE = 'PAGINATION_SAVE'

export const COOKIE_MAX_AGE = 604800 * 4 * 6 // 7 * 4 * 6 day
export const COOKIE_TOKEN = 'token'